// Reused across combined-action banners so we format lists like
// "Assay-A, Assay-B and Assay-C" consistently and don't re-allocate the
// (relatively expensive) ICU formatter on every render.
const CONJUNCTION_LIST_FORMAT = new Intl.ListFormat(undefined, {
  style: 'long',
  type: 'conjunction',
})

export function formatConjunctionList(items: string[]): string {
  return CONJUNCTION_LIST_FORMAT.format(items)
}
